import React, {FC, ReactElement} from "react";
import {Button, Grid} from "@mui/material";
import LoadingButton from "../../../components/button/LoadingButton";
import {observer} from "mobx-react";
import {ControlDivider} from "./NewEmployeeWizard";
import {newEmployeeWizardState} from "../../../store/NewEmployeeWizardState";
import ReviewBlock from "./ReviewBlock";
import {Trans, withTranslation} from "react-i18next";

interface IProps {
    handleBack: () => void
    handleNext: () => void
}

export const ReviewSection: FC<IProps> = observer(({handleBack, handleNext}): ReactElement => {
    return <>
        <ReviewBlock state={newEmployeeWizardState}/>
        <ControlDivider/>
        <Grid container spacing={1}>
            <Grid item>
                <Button variant="contained" color="secondary" onClick={handleBack}><Trans i18nKey="common.back">Back</Trans></Button>
            </Grid>
            <Grid item>
                <LoadingButton variant="contained" color="primary" onClick={handleNext}><Trans i18nKey="common.notify">Notify</Trans></LoadingButton>
            </Grid>
        </Grid>
    </>
});

export default withTranslation()(ReviewSection);